
<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_412_34825)">
      <path
        d="M8.51953 6.7334C8.5207 6.73419 8.52235 6.73587 8.52344 6.7373C8.52461 6.73893 8.52692
        6.74287 8.5293 6.75L9.21484 8.80762C9.38308 9.3122 9.66676 9.77048 10.043 10.1465C10.4192
        10.5225 10.8772 10.8066 11.3818 10.9746L13.4385 11.6592C13.4463 11.6618 13.4508 11.665
        13.4521 11.666C13.4534 11.667 13.4544 11.6679 13.4551 11.6689C13.4569 11.6717 13.4599
        11.6781 13.46 11.6875C13.46 11.6973 13.4569 11.7043 13.4551 11.707C13.4544 11.7081 13.4534
        11.709 13.4521 11.71C13.4508 11.711 13.4469 11.7133 13.4395 11.7158L11.3809 12.4014C10.8763
        12.5696 10.418 12.8534 10.042 13.2295C9.66598 13.6057 9.38281 14.0646 9.21484 14.5693L8.5293
        16.626L8.52832 16.6279C8.52636 16.6335 8.52337 16.6391 8.51855 16.6426C8.51357 16.6462 8.50712
        16.6474 8.50098 16.6475C8.49482 16.6475 8.4884 16.6462 8.4834 16.6426C8.47847 16.639 8.47462
        16.6337 8.47266 16.6279V16.626L7.78711 14.5684C7.61904 14.0641 7.33577 13.6054 6.95996
        13.2295C6.584 12.8535 6.12549 12.5695 5.62109 12.4014L3.5625 11.7158H3.56152C3.55569 11.7139
        3.5505 11.71 3.54688 11.7051C3.54324 11.7001 3.54102 11.6937 3.54102 11.6875C3.54109 11.6815
        3.54333 11.6758 3.54688 11.6709C3.55051 11.6659 3.55564 11.6621 3.56152 11.6602L3.5625
        11.6592L5.62109 10.9746V10.9736C6.12541 10.8055 6.58406 10.5224 6.95996 10.1465C7.28878
        9.8176 7.5468 9.42574 7.71875 8.99512L7.78711 8.80762L8.47266 6.75C8.4751 6.74267 8.47738 6.73886 8.47852
        6.7373C8.47958 6.7359 8.48032 6.73417 8.48145 6.7334C8.48419 6.73154 8.49121 6.72852 8.50098 6.72852C8.51023
        6.72854 8.51661 6.73155 8.51953 6.7334ZM4.54492 2.56641V2.56738C4.76408 3.22317 5.27873 3.73702
        5.93457 3.95605L6.81641 4.25L5.93457 4.54395C5.61095 4.65177 5.3164 4.83399 5.0752 5.0752C4.83421
        5.31625 4.65272 5.61024 4.54492 5.93359L4.25098 6.81641L3.95703 5.93359C3.8492 5.6101 3.6669 5.31632
        3.42578 5.0752C3.18462 4.83406 2.89093 4.65175 2.56738 4.54395L1.68359 4.25L2.56738 3.95605C2.89079
        3.84826 3.18469 3.6668 3.42578 3.42578C3.66698 3.18458 3.84921 2.89003 3.95703 2.56641L4.25098
        1.68359L4.54492 2.56641ZM1.33203 4.36719L1.33594 4.36523C1.33449 4.36577 1.3335 4.36768 1.33203
        4.36816L1.29297 4.25L1.33203 4.36719ZM11.6885 0.789062L11.7715 1.04004C11.9289 1.51338 12.3001
        1.88451 12.7734 2.04199L13.0234 2.125L12.7734 2.20898C12.5402 2.28665 12.3281 2.41798 12.1543
        2.5918C11.9805 2.76569 11.8491 2.97764 11.7715 3.21094L11.6885 3.46191L11.6045 3.21094C11.5268 2.97758
        11.3956 2.7657 11.2217 2.5918C11.0478 2.41791 10.8359 2.28661 10.6025 2.20898L10.3516
        2.125L10.6035 2.04199C11.077 1.88463 11.448 1.51343 11.6055 1.04004L11.6885 0.789062Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.708333"
      />
    </g>
    <defs>
      <clipPath id="clip0_412_34825">
        <rect
          width="17"
          height="17"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>